import { render, staticRenderFns } from "./BannerBlock.vue?vue&type=template&id=3cd7779a&scoped=true&"
import script from "./BannerBlock.vue?vue&type=script&lang=js&"
export * from "./BannerBlock.vue?vue&type=script&lang=js&"
import style0 from "./BannerBlock.vue?vue&type=style&index=0&id=3cd7779a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd7779a",
  null
  
)

export default component.exports